import React from 'react';
import { displayPrice } from 'utils';
import useListFlowValueGuide from '~/hooks/listFlow/useListFlowValueGuide';

interface Props {}

const ListFlowValueGuide: React.FC<Props> = () => {
  const { data: valueGuide } = useListFlowValueGuide();

  if (!valueGuide?.value_guide) {
    return null;
  }

  return (
    <div className="text-slate-green-500 mb-4 text-sm">
      Typically sells for{' '}
      <span className="font-bold text-green-500">
        ({displayPrice(valueGuide?.value_guide.median, false)})
      </span>{' '}
      <span className="font-semibold">
        ({displayPrice(valueGuide?.value_guide.p30, false)} -{' '}
        {displayPrice(valueGuide?.value_guide.p70, false)})
      </span>
    </div>
  );
};

export default ListFlowValueGuide;
